"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consistency = void 0;
const color_1 = require("./color");
exports.consistency = {
    ...color_1.colors,
    brandColors: color_1.brandColors,
    buffer: '20px',
    halfBuffer: '10px',
    borderRadius: '4px',
    extraSmallBuffer: '4px',
    smallBuffer: '8px',
    mediumBuffer: '16px',
    largeBuffer: '24px',
    extraLargeBuffer: '32px',
    allColors: color_1.allColors,
};
